import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-66fb14a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lg:hidden" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "logo SOS Méditerranée",
  class: "cursor-pointer w-28",
  src: _imports_0,
  onclick: "location.href='https://www.sosmediterranee.fr/';"
}, null, -1))
const _hoisted_4 = { class: "ml-2" }
const _hoisted_5 = { class: "text-base align-middle leading-5 text-main font-black uppercase" }
const _hoisted_6 = { class: "text-xs align-middle leading-3 text-secondary" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0 flex-grow w-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-main h-1" }, null, -1))
const _hoisted_9 = { class: "text-lg text-main flex flex-col font-black" }
const _hoisted_10 = { class: "list-disc pl-12 pt-6 pb-6 space-y-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-2 ml-2" }, "|", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-2 ml-2" }, "|", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-2 ml-2" }, "|", -1))
const _hoisted_14 = {
  href: "https://www.sosmediterranee.org/glossary/",
  target: "_blank"
}
const _hoisted_15 = {
  href: "https://www.sosmediterranee.org/operations/",
  target: "_blank"
}
const _hoisted_16 = {
  class: "bg-secondary text-donationText uppercase hover:bg-donationHoverBackground text-center rounded-b-lg",
  href: "https://don.sosmediterranee.org/?utm_source=sitesosmediterranee&utm_medium=site&utm_campaign=don_site_faireundon",
  target: "_blank"
}
const _hoisted_17 = { class: "hidden lg:block" }
const _hoisted_18 = { class: "bg-main text-white flex h-10 items-center header-desktop" }
const _hoisted_19 = { class: "flex-none flex" }
const _hoisted_20 = {
  href: "https://www.sosmediterranee.org/glossary/",
  target: "_blank",
  class: "px-1 flex-initial inline-block"
}
const _hoisted_21 = { class: "flex-none flex ml-8" }
const _hoisted_22 = {
  href: "https://www.sosmediterranee.org/operations/",
  target: "_blank",
  class: "px-1 flex-initial inline-block"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-2 ml-2" }, "|", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-2 ml-2" }, "|", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-2 ml-2" }, "|", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BurgerMenu = _resolveComponent("BurgerMenu")!
  const _component_HeaderContributorsMobile = _resolveComponent("HeaderContributorsMobile")!
  const _component_HeaderContributors = _resolveComponent("HeaderContributors")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("header.title")), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("header.subtitle")), 1)
        ]),
        _hoisted_7,
        _createVNode(_component_BurgerMenu, {
          "is-menu-visible": _ctx.store.getState().isMenuVisible,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateMenuVisibility()))
        }, null, 8, ["is-menu-visible"])
      ]),
      _hoisted_8,
      _createElementVNode("div", {
        style: _normalizeStyle(_ctx.maxHeightStyle(_ctx.store.getState().isMenuVisible)),
        class: _normalizeClass([_ctx.transitionClasses(), "right-0 bg-white w-full"])
      }, [
        _createElementVNode("nav", _hoisted_9, [
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", null, [
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLocale('en'))),
                class: _normalizeClass({activeLanguage: _ctx.$i18n.locale === 'en'})
              }, "EN", 2),
              _hoisted_11,
              _createElementVNode("span", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setLocale('fr'))),
                class: _normalizeClass({activeLanguage: _ctx.$i18n.locale === 'fr'})
              }, "FR", 2),
              _hoisted_12,
              _createElementVNode("span", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setLocale('it'))),
                class: _normalizeClass({activeLanguage: _ctx.$i18n.locale === 'it'})
              }, "IT", 2),
              _hoisted_13,
              _createElementVNode("span", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setLocale('de'))),
                class: _normalizeClass({activeLanguage: _ctx.$i18n.locale === 'de'})
              }, "DE", 2)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.$t("header.glossary")), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.$t("header.logBook")), 1)
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_HeaderContributorsMobile)
            ])
          ]),
          _createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.$t("header.donate.button2")), 1)
        ])
      ], 6)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("nav", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("a", _hoisted_20, _toDisplayString(_ctx.$t("header.glossary")), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("a", _hoisted_22, _toDisplayString(_ctx.$t("header.logBook")), 1)
        ]),
        _hoisted_23,
        _createElementVNode("span", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setLocale('en'))),
          class: _normalizeClass([{activeLanguage: _ctx.$i18n.locale === 'en'}, "cursor-pointer text-sm"])
        }, "EN", 2),
        _hoisted_24,
        _createElementVNode("span", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setLocale('fr'))),
          class: _normalizeClass([{activeLanguage: _ctx.$i18n.locale === 'fr'}, "cursor-pointer text-sm"])
        }, "FR", 2),
        _hoisted_25,
        _createElementVNode("span", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setLocale('it'))),
          class: _normalizeClass([{activeLanguage: _ctx.$i18n.locale === 'it'}, "cursor-pointer text-sm"])
        }, "IT", 2),
        _hoisted_26,
        _createElementVNode("span", {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setLocale('de'))),
          class: _normalizeClass([{activeLanguage: _ctx.$i18n.locale === 'de'}, "mr-4 cursor-pointer text-sm"])
        }, "DE", 2),
        _createVNode(_component_HeaderContributors)
      ])
    ])
  ]))
}